import type { WorkingDaysInfo } from "~/utils/workingDays";

import { MONTH_NAMES } from "../types/salesGoals";

interface MonthlyAnalysisHeaderProps {
  month: number;
  year: number;
  workingDays: WorkingDaysInfo;
}

export default function MonthlyAnalysisHeader({
  month,
  year,
  workingDays,
}: MonthlyAnalysisHeaderProps) {
  const stats = [
    { label: "Mes", value: `${MONTH_NAMES[month]} ${year}` },
    { label: "Días Hábiles", value: workingDays.totalWorkingDays },
    { label: "Transcurridos", value: workingDays.elapsedWorkingDays },
    { label: "Restantes", value: workingDays.remainingWorkingDays },
  ];

  return (
    <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
      {stats.map((s) => (
        <div
          key={s.label}
          className="rounded-lg border bg-card p-3 text-center"
        >
          <div className="text-xs text-muted-foreground">{s.label}</div>
          <div className="text-sm font-semibold">{s.value}</div>
        </div>
      ))}
    </div>
  );
}
